import * as request from 'superagent'
import { ENV } from 'config'
import { ENV_DEV } from 'common/constants'
import { assign } from 'lodash'
import Queue from './queue'
import { logLevels } from './levels'

declare var BUILD_TIMESTAMP: string
declare var BUILD_VERSION: number

const STDOUT: number = 0
const APIOUT: number = 1

export const REQUEST_TIMEOUT: number = 300
export const MIN_NEW_REQUEST_TIMEOUT: number = 300000 // 5min
export const MAX_NEW_REQUEST_TIMEOUT: number = 600000 // 10min
export const DEFAULT_CLIENT_NAME: string = 'auto1_web'
export const DEFAULT_CONFIG: any = {
  [logLevels.INFO]: STDOUT,
  [logLevels.WARN]: APIOUT,
  [logLevels.ERROR]: APIOUT,
  [logLevels.BACKEND_500]: STDOUT
}

export default class Logger {
  private endpoint: string
  private env: string
  private clientName: any
  private getClientInfo: any
  private userUuid: string
  private agent: string
  private version: number
  private buildTimestamp: string
  public timeout: any
  public queue: Array<any>

  constructor(
    endpoint,
    userUuid,
    getClientInfo = () => ({}),
    agent = navigator['userAgent'],
    clientName = DEFAULT_CLIENT_NAME,
    version = BUILD_VERSION,
    buildTimestamp = BUILD_TIMESTAMP
  ) {
    this.endpoint = endpoint
    this.queue = []
    this.timeout = undefined
    this.clientName = clientName
    this.getClientInfo = getClientInfo
    this.userUuid = userUuid
    this.agent = agent
    this.version = version
    this.buildTimestamp = buildTimestamp

    if (typeof this.endpoint !== 'string' || this.endpoint === '') {
      throw new Error('Invalid loggerUrl in the store')
    }
  }

  public getTimeoutValue() {
    return (
      Math.floor(
        Math.random() * (MAX_NEW_REQUEST_TIMEOUT - MIN_NEW_REQUEST_TIMEOUT + 1)
      ) + MIN_NEW_REQUEST_TIMEOUT
    )
  }

  public stdout(params) {
    console.log(params)
  }

  public async emptyQueue() {
    if (this.queue.length === 0) {
      return
    }

    if (typeof this.timeout !== 'undefined') {
      clearTimeout(this.timeout)
    }

    for (let x = 0; x < this.queue.length; x += 1) {
      if ((await this.apiout(this.queue[x])) === true) {
        this.queue.splice(x, 1)
      } else {
        break
      }
    }
  }

  public apiout(params: any, req = request) {
    return new Promise(async (resolve, reject) => {
      if (typeof this.timeout !== 'undefined') {
        this.queue.push(params)
        return resolve(true)
      }

      const response = await req.post(this.endpoint).send(params)

      if (response.status !== 201) {
        this.queue.push(params)
        this.timeout = setTimeout(this.emptyQueue, this.getTimeoutValue())

        return resolve(false)
      }

      return resolve(true)
    })
  }

  public prepareLogs(params, level = logLevels.INFO) {
    const result = assign(
      {},
      params,
      {
        level,
        client: this.clientName,
        agent: this.agent,
        url: window ? window.location.href : '',
        user_uuid: this.userUuid,
        version: this.version,
        build_timestamp: this.buildTimestamp
      },
      this.getClientInfo()
    )

    if (params.error && params.error.stack) {
      result.error = params.error.stack
    }

    return result
  }

  public log(params, level = logLevels.INFO) {
    const toLog = this.prepareLogs(params, level)

    if (ENV === ENV_DEV) {
      return this.stdout(toLog)
    }

    const driver =
      typeof DEFAULT_CONFIG[level] === 'undefined'
        ? STDOUT
        : DEFAULT_CONFIG[level]

    switch (driver) {
      case STDOUT:
        this.stdout(toLog)
        break

      case APIOUT:
        this.apiout(toLog)
        break
    }
  }

  public info(params) {
    return this.log(params, logLevels.INFO)
  }

  public error(params) {
    return this.log(params, logLevels.ERROR)
  }

  public warn(params) {
    return this.log(params, logLevels.WARN)
  }
}

let logger
const queue = new Queue()

export function init(endpoint, userUuid, getClientInfo = () => ({})) {
  if (typeof logger === 'undefined') {
    logger = new Logger(endpoint, userUuid, getClientInfo)

    if (queue.messages.length > 0) {
      queue.messages.forEach(msg => logger.log(msg.params, msg.level))
      queue.messages = []
    }
  }
}

export function getLogger() {
  if (typeof logger === 'undefined') {
    return queue
  }

  return logger
}

export { logLevels }
